export class CalculatorModel {
  product: string;
  savingsPlan: string;
  dob: any;
  duration: string;
  frequency: string;
  amount: number;
  effectiveDate: string;

  constructor() {
    this.product = 'corporate-savings';
    this.savingsPlan = '';
    this.dob = '';
    this.duration = '';
    this.frequency = '';
    this.amount = 0;
    this.effectiveDate = '';
  }
}
